import { useLayoutEffect } from "react";
import { ToastContainer } from "react-toastify";

import LogoLoading from "components/LogoLoading";
import { useSignUpAndSignIn } from "hooks/useAutoSignUpAndSignIn";
import PlayGame from "pages/PlayGame";
import { TENANT_ID } from "utils";

const App = () => {
  const { loading: autoSignUpAndSignInLoading, autoSignUpAndSignIn } =
    useSignUpAndSignIn();

  const query = new URLSearchParams(window.location.search);
  const tenantId = query.get(TENANT_ID);

  useLayoutEffect(() => {
    if (!tenantId) return;
    autoSignUpAndSignIn();
  }, [tenantId]);

  if (autoSignUpAndSignInLoading) return <LogoLoading />;

  return (
    <div className="main-layout">
      <PlayGame />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </div>
  );
};

export default App;
